import React, { useState } from "react";
import SyncIcon from "@mui/icons-material/Sync";
import DeployCache, {
  isShowCache,
} from "src/components/deployCache/DeployCache";
import { CACHE_CUSTOMER } from "src/constants/actionCache";
import ShowCacheFLFCustomer from "../ShowCache/ShowCacheFLFCustomer";
import Controls from "src/components/form/controls/Controls";
import { allowedToUpdateEntity } from "src/constants/role";
import useAuth from "src/hooks/useAuth";

const FLFCustomerControlPanel = ({
  children,
  currentActionCache,
  permissionsAccessControl,
  handleRefreshCache,
}) => {
  const { auth } = useAuth();
  const [disableButton, setDisableButton] = useState(false);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>{children}</div>
      <div>
        <DeployCache
          title="Cache Customer"
          isShowButton={isShowCache(currentActionCache, CACHE_CUSTOMER)}
        >
          <ShowCacheFLFCustomer
            disableButton={disableButton}
            setDisableButton={setDisableButton}
          />
        </DeployCache>

        {allowedToUpdateEntity(auth?.permissions, permissionsAccessControl) && (
          <Controls.Button
            text="Refresh Cache"
            variant="outlined"
            startIcon={<SyncIcon />}
            onClick={handleRefreshCache}
          />
        )}
      </div>
    </div>
  );
};

export default FLFCustomerControlPanel;
